import { Spinner } from "native-base";
import React from "react";
import { blixtTheme } from "../native-base-theme/variables/commonColor";

export default () => <Spinner style={{}} size="small" color={blixtTheme.light} />;
